import React from 'react'
import { observer } from 'mobx-react'
import styles from './MilestoneCompletionModal.sass'
import MilestoneProgress from '../MilestoneProgress'
import ConfettiCannon from 'components/ConfettiCannon'
import MilestonesViewModel from '../MilestonesViewModel'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSection,
  ModalSheetHeader,
} from 'components/ModalSheet'
import Button from 'components/Button'

interface MilestoneCompletionModalProps {
  vm: MilestonesViewModel
  isCardLayout?: boolean
}

export default observer(function MilestoneCompletionModal({
  vm,
  isCardLayout,
}: MilestoneCompletionModalProps) {
  const modal = vm.completionModal
  const isLast = modal.allMilestonesCompleted
  const suffix = isCardLayout ? 'new' : 'classic'

  return (
    <ModalSheet showing={modal.showing} onRequestClose={modal.hide}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <div className={styles.cannon}>
            <ConfettiCannon
              delay={800}
              // Where to spawn the confetti.
              // This should be at the trophy opening.
              confettiSource={{
                width: 5,
                x: 380,
                y: 85,
              }}
            />
          </div>
          <div className={styles.progress}>
            <MilestoneProgress
              size="big"
              totalCount={1}
              completedCount={1}
              spin
            />
          </div>
        </ModalSheetContentBlock>
        <div className={styles.content}>
          <ModalSheetContentTitle>
            Congrats! <br />
            {isLast
              ? 'That was the last Milestone!'
              : "You've completed a Milestone!"}
          </ModalSheetContentTitle>
          <ModalSheetContentDescription compact>
            {isLast
              ? 'You have no outstanding tasks to complete.'
              : "You're another step closer to finishing this job!"}
          </ModalSheetContentDescription>
        </div>
      </ModalSheetContent>
      <ModalSheetFooterSection>
        <ModalSheetFooterButtonGroup stacked>
          <Button
            size="wide"
            type="primary"
            onClick={modal.proceed}
            data-test={`milestone-completion-acknowledgment-${suffix}`}
          >
            {isLast ? 'Awesome!' : 'Proceed To Next Milestone'}
          </Button>
          {!isLast && (
            <Button
              onClick={modal.hide}
              type="text"
              size="wide"
              data-test={`milestone-completion-cancel-${suffix}`}
            >
              I'm not ready yet
            </Button>
          )}
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooterSection>
    </ModalSheet>
  )
})
